import { render, staticRenderFns } from "./detach-vehicle.vue?vue&type=template&id=9ce8bd92&scoped=true"
var script = {}
import style0 from "./detach-vehicle.vue?vue&type=style&index=0&id=9ce8bd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce8bd92",
  null
  
)

export default component.exports